<script setup>

</script>

<template>
    <svg class="stroke-slate-500 stroke-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">

            <path d="M7.33398 2.66602H2.66732C2.3137 2.66602 1.97456 2.80649 1.72451 3.05654C1.47446 3.30659 1.33398 3.64573 1.33398 3.99935V13.3327C1.33398 13.6863 1.47446 14.0254 1.72451 14.2755C1.97456 14.5255 2.3137 14.666 2.66732 14.666H12.0007C12.3543 14.666 12.6934 14.5255 12.9435 14.2755C13.1935 14.0254 13.334 13.6863 13.334 13.3327V8.66602"  stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.334 1.66617C12.5992 1.40095 12.9589 1.25195 13.334 1.25195C13.7091 1.25195 14.0688 1.40095 14.334 1.66617C14.5992 1.93138 14.7482 2.29109 14.7482 2.66617C14.7482 3.04124 14.5992 3.40095 14.334 3.66617L8.00065 9.9995L5.33398 10.6662L6.00065 7.9995L12.334 1.66617Z"  stroke-linecap="round" stroke-linejoin="round"/>

    </svg>

</template>

<style scoped>

</style>
